import apiClient from "@/app/api/client";
import { replaceParams, taskScheduleEndpoints } from "@/app/api/endpoints";
import type {
	CreateTaskScheduleRequest,
	ListTaskSchedulesParams,
	PaginatedResponse,
	SuccessResponse,
	TaskSchedule,
	UpdateTaskScheduleRequest,
} from "../types";

export const taskScheduleService = {
	async list(params?: ListTaskSchedulesParams): Promise<PaginatedResponse<TaskSchedule>> {
		const response = await apiClient.get<PaginatedResponse<TaskSchedule>>(
			taskScheduleEndpoints.list,
			{ params }
		);
		return response.data;
	},

	async getById(id: string): Promise<TaskSchedule> {
		const url = replaceParams(taskScheduleEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<TaskSchedule>>(url);
		return response.data.data;
	},

	async create(data: CreateTaskScheduleRequest): Promise<TaskSchedule> {
		const response = await apiClient.post<SuccessResponse<TaskSchedule>>(
			taskScheduleEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateTaskScheduleRequest): Promise<TaskSchedule> {
		const url = replaceParams(taskScheduleEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<TaskSchedule>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(taskScheduleEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
